import { User, UserMin } from '@apiContract';

import { useSettings } from './useSettings';
import { useUserLocation } from './useUserLocation';
import { getRoutesList } from 'src/utils/mappers';
import { useRoutesByLocation } from './useRoutesByLocation';
import { useGetGroupsForPickQuery } from 'src/redux/api/groups';

type Settings = {
  AssignmentCardShowUserId: boolean;
  AssignmentCardShowAutoAssignId: boolean;
  AssignmentCardShowRoutes: boolean;
  AssignmentCardShowLocation: boolean;
  AssignmentCardShowGroup: boolean;
};

const getStringValue = (str?: any) => str ? str : '';

const getString = (value1: any, value2: any) => {
  return `${getStringValue(value1)}${getStringValue(value1 && value2 && ' • ')}${getStringValue(value2)}`
}

export const useUserInfoLines = (user?: User | UserMin | null) => {
  const settings = useSettings([
    'AssignmentCardShowUserId',
    'AssignmentCardShowAutoAssignId',
    'AssignmentCardShowRoutes',
    'AssignmentCardShowLocation',
    'AssignmentCardShowGroup',
  ]) as Settings;

  const { data, isLoading: isLoadingGroups } = useGetGroupsForPickQuery(undefined, { skip: !user?.groupIds?.length });

  const { location, isLoading: isLocationResponseLoading } = useUserLocation(user);
  const { isLoading: isRoutesLoading, data: routes } = useRoutesByLocation(location?.id);

  const userID = settings.AssignmentCardShowUserId && user?.userName;
  const userAutoassignId = settings.AssignmentCardShowAutoAssignId && user?.autoAssignId;
  const userLocation = settings.AssignmentCardShowLocation && location?.name;
  const userRoute = settings.AssignmentCardShowRoutes && getRoutesList(routes);
  const userGroups = user?.groupIds?.map((id) => data?.[id].name);

  return {
    idLine: getString(userID, userAutoassignId),  
    routesLine: getString(userRoute, userLocation),         
    isRoutesLoading: isLocationResponseLoading || isRoutesLoading,
    isLoadingGroups,
    userGroups,
    showGrowps: settings.AssignmentCardShowGroup,
  }
};